import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"git-repository-commits"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 15V2H7.5C5.567 2 4 3.567 4 5.5V17.5M20 15V22H17M20 15H17.5M8.5 15H7.5C5.567 15 4 16.567 4 18.5C4 20.433 5.567 22 7.5 22H9M9.00391 6.00391H9V6H9.00391V6.00391ZM9.00391 9.00391H9V9H9.00391V9.00391Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 18.3948L13 16L15.5 18.3948M13 17.25V22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GitRepositoryCommits = Vue.extend<IconProps>({
  name: 'GitRepositoryCommitsIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'git-repository-commits',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GitRepositoryCommits;
